'use client';

import React from 'react';
import { Menu, X } from 'lucide-react';

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
  alwaysVisible?: boolean;
}

export function MobileMenuButton({ isOpen, onClick, alwaysVisible = false }: MobileMenuButtonProps) {
  return (
    <button
      onClick={onClick}
      // Floating toggle for the sidebar drawer — must outrank the chat header
      // (which carries `pl-14` on mobile to clear this button). `z-drawer` is
      // the named token for side-drawer-level surfaces (see the shared z scale
      // in packages/shared-config/tailwind-z-index.cjs); no magic z numbers.
      className={`${alwaysVisible ? '' : 'md:hidden'} fixed z-drawer p-2 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors shadow-lg`}
      style={{
        top: 'max(1rem, env(safe-area-inset-top))',
        left: 'max(1rem, env(safe-area-inset-left))',
      }}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      title={isOpen ? 'Close menu' : 'Open menu'}
    >
      {isOpen ? (
        <X className="w-6 h-6 text-slate-800 dark:text-white" />
      ) : (
        <Menu className="w-6 h-6 text-slate-800 dark:text-white" />
      )}
    </button>
  );
}
















